import Vue from 'vue';

// function debounce(fn, wait = 500) {
//     let timer = null
//     return function() {
//         let now = !timer
//         timer && clearTimeout(timer)
//         timer = setTimeout(() => {
//             timer = null
//         }, wait)
//         if (now) {
//             fn.apply(this, arguments)
//         }
//     }
// }

// function throttle(fn, wait = 500) {
//     let last = 0
//     return function() {
//         let now = Date.now()
//         if (now - last > wait) {
//             fn.apply(this, arguments)
//             last = now
//         }
//     }
// }
// Vue.directive('throttle', {
//     bind(el, binding) {
//         let executeFunction
//         if (binding.value instanceof Array) {
//             const [func, timer] = binding.value;
//             executeFunction = throttle(func, timer);
//         } else {
//             console.error(`throttle指令绑定的参数必须是数组，且需执行的事件类型或函数或时间间隔不能为空`)
//             return
//         }
//         el.addEventListener('click', executeFunction);
//     }
// })

// // 注册全局防抖指令
// Vue.directive('debounce', {
//     bind(el, binding) {
//         let executeFunction
//         if (binding.value instanceof Array) {
//             const [func, timer] = binding.value;
//             executeFunction = debounce(func, timer);
//         } else {
//             console.error(`debounce指令绑定的参数必须是数组，且需执行的事件类型或函数或时间间隔不能为空`)
//             return
//         }
//         el.addEventListener('click', executeFunction);
//     }
// })


// 在组件中使用案例
// {
/* <template>
  <div class="page-container">
    <div style="margin-top:40px;height:40px;"></div>
    <button v-throttle="[()=>throttleCallBack('throttle'),500]">
      点我（节流）
    </button>
    <button v-debounce="[()=>debounceCallBack('debounce'),500]">
      点我（防抖）
    </button>
  </div>
</template>

<script>
export default {
  methods: {
    throttleCallBack(val) {
      console.log('点击了节流按钮',val);
    },
    debounceCallBack(val) {
      console.log('点击了防抖按钮',val);
    },
  }
};
</script> */
// }

export default {

    /**
     * 函数防抖
     * 触发事件后在n秒后执行，如果n秒内又触发事件，则重新计算时间
     */
    debounce(fn, wait = 1000) {
        let timer;
        return function() {
            let context = this;
            let args = arguments;
            if (timer) clearTimeout(timer);
            timer = setTimeout(() => {
                fn.apply(context, args);
            }, wait)
        }
    },

    /**
     * 函数节流
     * 触发事件立即执行，但在n秒内连续触发则不执行
     */
    throttle(fn, wait = 1000) {
        let timer;
        return function() {
            if (timer != null) return;
            let context = this;
            let args = arguments;
            fn.apply(context, args);
            timer = setTimeout(() => {
                timer = null;
            }, wait);
        }
    },
}


// WEBPACK FOOTER //
// ./src/assets/js/directives.js